import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { PessoaParametroRequestModel } from 'model/api/gestao/pessoa/pessoa-parametro-request-model';

export function usePutPessoaParametro() {
  const { invocarApi, ...outrasPropriedades } = useApiBase();

  const putPessoaParametro = useCallback(
    (model: PessoaParametroRequestModel) =>
      invocarApi({
        method: 'PUT',
        url: `/${VariaveisAmbiente.apiVersion}/pessoa/${model.pessoaId}/parametro/${model.id}`,
        data: model,
        enviarTokenUsuario: true,
      }),
    [invocarApi],
  );
  return {
    ...outrasPropriedades,
    putPessoaParametro,
  };
}
